module.exports = __webpack_public_path__ + "img/9788996995951.3fca2f20.jpg";